export * from './button'
import { default as Button } from './button'

export default Button
